import { useEffect, useState } from "react";
import GradingCard from "../../components/gradingcard/GradingCard";
import GradingHeader from "../../components/gradingheader/GradingHeader";
import Header from "../../components/header/Header";
import Sidenav from "../../components/sidenav/Sidenav";
import GradingModal from "../../components/gradingmodal/GradingModal";
import { Wrapper, ClinicSection, FormContainer } from "./ClinicDetails.styles";
import { Text, Grid } from "./Grading.styles";
import EmbroysExampleImage from "../../assets/images/embryos-example.png";
import OocytesExampleImage from "../../assets/images/oocytes-example.png";
import InputBox from "../../components/input/InputBox";
import AddRating from "../../components/addrating/AddRating";
import { loadAllGradingList } from "../../services/grading.service";
import { useToast } from "../../contexts/ToastContext";
import MyTable from "../../components/table/MyTable";
import withAuth from "../../hocs/withAuth";
import { addClinicUrls } from "../../services/clinic-detail.service";
import validator from "../../validarions/additionalInfo.validation";
import { GradingRecordProps } from "../../types";
import useLoader from "../../hooks/useLoader";

const modalData = {
  Embryos: {
    heading: "Embryos - App Example",
    subtitle:
      "Here is an example of how grades will look within the patient app",
    imageOne: EmbroysExampleImage,
  },
  Oocytes: {
    heading: "Oocytes - App Example",
    subtitle: "Add ratings such as “Mature” for maurity levels, i.e. “MII”",
    imageOne: OocytesExampleImage,
  },
};

const formItems = [
  {
    id: "Embryo",
    labelName: "Embryo Grading URL",
    placeHolderName: "Embryo Grading URL",
    type: "text",
    keyName: "embryoGradingUrl",
  },
  {
    id: "Oocyte",
    labelName: "Oocyte Maturity Levels URL",
    placeHolderName: "Oocyte Maturity Levels URL",
    type: "text",
    keyName: "eggGradingUrl",
  },
];

type otherDetailsType = {
  value: string;
  error: string;
};

function Grading() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("");
  const [show, setShow] = useState(false);
  const [list, setList] = useState<{ embryos: []; oocytes: [] }>({
    embryos: [],
    oocytes: [],
  });
  const [otherDetails, setOtherDetails] = useState<{
    embryoGradingUrl: otherDetailsType;
    eggGradingUrl: otherDetailsType;
  }>({
    embryoGradingUrl: { value: "", error: "" },
    eggGradingUrl: { value: "", error: "" },
  });
  const [currentlySelected, setCurrentlySelected] =
    useState<GradingRecordProps | null>(null);
  const { loading, startLoading, stopLoading } = useLoader();

  const toast = useToast();

  const handleClose = () => {
    setOpen(false);
    setActive("");
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const displayAddRating = () => {
    setShow((prev) => !prev);
  };

  const addOtherResources = () => {
    let hasError = false;
    for (let key in otherDetails) {
      if (Boolean(otherDetails[key as keyof typeof otherDetails].error)) {
        hasError = true;
        break;
      }
    }
    console.log(hasError);
    if (!hasError)
      addClinicUrls(
        {
          embryoGradingUrl: otherDetails["embryoGradingUrl"].value,
          oocytesGradingUrl: otherDetails["eggGradingUrl"].value,
        },
        startLoading,
        stopLoading,
        toast?.displayMessage
      );
  };

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    const errorMessage = validator["validateUrlString"](
      value,
      id === "embryoGradingUrl" ? "Embryos" : "Oocytes"
    );
    setOtherDetails((prev) => ({
      ...prev,
      [id]: {
        value,
        error: errorMessage,
      },
    }));
  };

  useEffect(() => {
    if (!show)
      loadAllGradingList(setList, setOtherDetails, toast?.displayMessage);
  }, [show]);

  return (
    <Wrapper>
      <Sidenav />
      <ClinicSection>
        {show ? (
          <AddRating
            active={active}
            goBack={displayAddRating}
            currentlySelected={currentlySelected}
          />
        ) : (
          <>
            <Header text={"Grading & Maturity Levels"} showBtn={false} />
            <Text>
              Set up your embryo grading system and oocyte maturity levels to
              view in the patient app.
            </Text>
            <div>
              <div>
                <GradingHeader
                  text={"Embryos"}
                  viewExample={true}
                  viewExampleCallback={() => {
                    handleOpen();
                    setActive("Embryos");
                  }}
                  actionTitle={"Add Rating"}
                  actionHandler={() => {
                    displayAddRating();
                    setCurrentlySelected(null);
                    setActive("Embryos");
                  }}
                  appPreview={Boolean(active)}
                />
                {list["embryos"].length > 0 ? (
                  <MyTable
                    headers={["Rating", "Grade(s)", "Description"]}
                    data={list["embryos"]}
                    handleClick={(data: GradingRecordProps) => {
                      displayAddRating();
                      setActive("Embryos");
                      setCurrentlySelected(data);
                    }}
                  />
                ) : (
                  <GradingCard
                    title="No embryo Ratings yet"
                    subtitle="Add ratings such as “Excellent” or “Average” for grades, i.e. “3AA” or “abnormal”"
                  />
                )}
              </div>
              <div>
                <GradingHeader
                  text={"Oocytes"}
                  viewExample={true}
                  viewExampleCallback={() => {
                    handleOpen();
                    setActive("Oocytes");
                  }}
                  actionTitle={"Add Rating"}
                  actionHandler={() => {
                    displayAddRating();
                    setCurrentlySelected(null);
                    setActive("Oocytes");
                  }}
                  appPreview={Boolean(active)}
                />
                {list["oocytes"].length > 0 ? (
                  <MyTable
                    headers={["Rating", "Grade(s)", "Description"]}
                    data={list["oocytes"]}
                    handleClick={(data: GradingRecordProps) => {
                      displayAddRating();
                      setActive("Oocytes");
                      setCurrentlySelected(data);
                    }}
                  />
                ) : (
                  <GradingCard
                    title="No Oocyte Maturity Levels yet"
                    subtitle="Add ratings such as “Mature” for maurity levels, i.e. “MII”"
                  />
                )}
              </div>
              <div>
                <GradingHeader
                  text={"Additional Information"}
                  viewExample={false}
                  actionTitle={"Save Changes"}
                  actionHandler={addOtherResources}
                  loading={loading}
                />
                <FormContainer>
                  {formItems.map((formItem, idx) => {
                    const { keyName } = formItem;
                    return (
                      <Grid key={idx}>
                        <InputBox
                          value={
                            otherDetails[keyName as keyof typeof otherDetails]
                              .value
                          }
                          error={
                            otherDetails[keyName as keyof typeof otherDetails]
                              .error
                          }
                          handler={handleFormChange}
                          {...formItem}
                          style={{ width: "98%" }}
                          id={keyName}
                        />
                      </Grid>
                    );
                  })}
                </FormContainer>
              </div>
            </div>
          </>
        )}
      </ClinicSection>

      <GradingModal
        open={open}
        handleClose={handleClose}
        {...modalData[active as keyof typeof modalData]}
      />
    </Wrapper>
  );
}

export default withAuth(Grading);
